export const queryKeys = {
  SIPUNI_CONFIG: 'SIPUNI_CONFIG',
  SIPUNI_CONFIG_EMPLOYEE: 'SIPUNI_CONFIG_EMPLOYEE',
  SIPUNI_CONFIG_CALL_HANDLING: 'SIPUNI_CONFIG_CALL_HANDLING',
  SIPUNI_CONFIG_CONTACT: 'SIPUNI_CONFIG_CONTACT'
};
